<template>
    <TagComponent :variant="getVariant(priority)" :value="formatPriority(priority)" />
</template>

<script setup lang="ts">
import TagComponent from '@/components/ui/tag/TagComponent.vue';

withDefaults(
    defineProps<{
        priority?: string | null;
    }>(),
    {
        priority: null,
    },
);

function getVariant(priority: string | null) {
    if (!priority) return 'default';
    switch (priority.replace(/\s+/g, '').toLowerCase()) {
        case 'crisis':
        case 'critical':
            return 'danger';
        case 'high':
            return 'warning';
        case 'medium':
            return 'gold';
        case 'low':
            return 'success';
        case 'verylow':
            // Muted family so Very low reads a step quieter than Low.
            return 'success-muted';
        case 'underreview':
            return 'info';
        default:
            return 'default';
    }
}

function formatPriority(priority: string | null) {
    if (!priority) return '';
    // Wire values are PascalCase enum names (e.g. 'UnderReview', 'VeryLow') — space them out first.
    const spaced = priority.replace(/([a-z])([A-Z])/g, '$1 $2');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}
</script>
